<main class="wrapper">
  <app-block-header></app-block-header>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
  <app-block-footer></app-block-footer>
</main>
<app-toast></app-toast>
